import React from "react"
import moment from "moment/moment"

const postMeta = ( { post } ) => (
     <span className="post-meta">{moment(post.date).format(`MMM Do YYYY`)}</span>
)

export default postMeta